<div data-cy="empty-list-warning" class="alert alert__warning text-center m-20">
  <ng-content></ng-content>
</div>
